/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-lonely-if */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import './filtersModal.scss';

const FiltersModal = (props) => {
  // How to trap focus
  // https://uxdesign.cc/how-to-trap-focus-inside-modal-to-make-it-ada-compliant-6a50f9a70700
  // React has issues with document.getElementById
  // https://stackoverflow.com/questions/40256673/getelementbyid-in-react
  // add all the elements inside modal which you want to make focusable
  const focusableElements = 'button, [href], input, select, .sb-filter, .sb-filters, .sb-filter-number-results, [tabindex]:not([tabindex="-1"])';
  let modal;
  let focusableContent;
  let firstFocusableElement;
  let lastFocusableElement;

  useEffect(() => {
    modal = document.getElementById('Google-Map-Filter-Modal'); // select the modal by it's id
    focusableContent = modal.querySelectorAll(focusableElements);
    firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
  });

  const handleMarkerKeyPress = (event) => {
    if (event.key === 'Escape') {
      // ADA - Escape to close modal
      props.handleClickHideFilters();
    } else if (event.key === 'Tab') {
      // ADA - Tab/Shift-Tab trap
      if (event.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus(); // add focus for the last focusable element
          event.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
          firstFocusableElement.focus(); // add focus for the first focusable element
          event.preventDefault();
        }
      }
    }
  };

  const locations = props.loadingStatus 
    ? <span className="sb-filter-number-results"><Translation>{(t) => t('Loading')}</Translation>...</span>
    : <span className="sb-filter-number-results">
    {(typeof props.matchesFilterCount === 'number') ? props.matchesFilterCount : props.locations.length} matching locations
  </span>;

  return (
    <>
      <div className="sb-location-finder-transparency-background"></div>
      <div
        role="dialog"
        tabIndex="-1"
        className="sb-filters-modal"
        id="Google-Map-Filter-Modal"
        aria-labelledby="open-filter-modal"
        aria-modal="true"
        onKeyDown={ () => { handleMarkerKeyPress(event); } }
      >
        <button aria-label={i18n.t('close')} onClick={props.handleClickHideFilters} className="sb-modal-close-button">&#x2716;</button>
        <h2 className="sb-modal-heading"><Translation>{(t) => t('Advanced Search')}</Translation></h2>
        <div className="sb-filters" id="modalFilters" aria-label={i18n.t('mapFilters')}>
          {props.filtersListContent}
        </div>
        <div className="sb-filter-controls">
          {locations}
          <button
            className="sb-filter-controls-back"
            onClick={props.handleClickHideFilters}
            aria-label={i18n.t('backFromFilter')}
          >
            <Translation>{(t) => t('View results')}</Translation>
          </button>
        </div>
      </div>
    </>
  );
};

FiltersModal.propTypes = {
  filtersListContent: PropTypes.array,
  handleClickHideFilters: PropTypes.func,
  loadingStatus: PropTypes.bool,
  locations: PropTypes.array,
  matchesFilterCount: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default FiltersModal;
